import script from "./BaseTableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTableComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTableComponent.vue?vue&type=style&index=0&id=0216c7ab&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0216c7ab"]])

export default __exports__